import Icons from "@/components/Icon"
import { getKey } from "@/components/util"
import { StylesProps } from "@/types/props"
import classNames from "classnames"
import Link from "next/link"
import React, { useEffect, useState } from "react"
import style from "./style.scss"

export interface NavigationItemProps {
  index?: number
  icon?: string
  label?: string
  href?: string
  as?: string
  children?: NavigationItemProps[]
  styles?: StylesProps
  newMissionCount?: number | null
  setOpen?: any
  open?: boolean
  depth?: number
}

const ParentNode: React.SFC<Readonly<NavigationItemProps>> = (props) => {
  const Icon = getKey(Icons, props.icon)

  return (
    <>
      <div className={style.title} onClick={() => props.setOpen(!props.open)}>
        {Icon && <Icon className={style.icon} />}
        <div className={style.label}>{props.label}</div>
      </div>
      <ul className={style.children}>
        {props.children &&
          props.children.map((child, index) => (
            <NavigationItem
              key={index}
              {...child}
              newMissionCount={props.newMissionCount}
              depth={typeof props.depth !== "undefined" ? props.depth + 1 : 0}
            />
          ))}
      </ul>
    </>
  )
}

const LinkNode: React.SFC<Readonly<NavigationItemProps>> = (props) => {
  const Icon = getKey(Icons, props.icon)

  return (
    <Link href={props.href} as={props.as} prefetch>
      <a href={props.href} className={style.link}>
        {Icon && <Icon className={style.icon} />}
        <div className={style.label}>{props.label}</div>
        {props.newMissionCount != null && props.newMissionCount > 0 && (
          <span className={style.tag}>
            {props.href === "/missions" && props.newMissionCount}
          </span>
        )}
      </a>
    </Link>
  )
}

const NavigationItem: React.SFC<Readonly<NavigationItemProps>> = (props) => {
  const [open, setOpen] = useState<boolean>(false)
  const [active, setActive] = useState<boolean>(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      setActive(
        props.href === window.location.pathname ||
          props.as === window.location.pathname
      )
    }
  })

  return (
    <li
      className={classNames(
        style.navigationItem,
        style[`navigationItem--${props.children ? "parent" : "child"}`],
        {
          [style[`navigationItem--open`]]: open,
          [style[`navigationItem--active`]]: active
        }
      )}
      data-depth={props.depth}
    >
      {props.children ? (
        <ParentNode {...props} setOpen={setOpen} open={open} />
      ) : (
        <LinkNode {...props} />
      )}
    </li>
  )
}

export default NavigationItem
